import { Routes, Route, useSearchParams } from "react-router-dom";
import BalanceLookup from "../lookup/BalanceLookup";
import DocLink from './DocLink';
import Privacy from "./Privacy";
import TandC from "./TandC";
import Refund from "./Refund";
import ContactUs from "./ContactUs";
import ShortTandC from "./ShortTandC";
import MiscFees from "../miscFees/MiscFees";
import LandingPageSource from "./LandingPageSource";

const MainRouter = () => {

    const [searchParams] = useSearchParams();
    // Links to an agency's landing page carry its courtLinkArg, as ?agency= or
    // ?agencyId=; with &partyId= they go straight to that party's balances.
    const agencyId = searchParams.get('agency') || searchParams.get('agencyId')
    const court = searchParams.get('court')
    const partyId = searchParams.get('partyId')
    return (
        <Routes>
            <Route path="/" element={<LandingPageSource agencyId={agencyId ? agencyId : ''} court={court} partyId={partyId}/>} />
            <Route path="/home" element={<LandingPageSource agencyId={agencyId ? agencyId : ''} court={court} partyId={partyId} />} />
            <Route path="/balanceLookup" element={<BalanceLookup />} />
            <Route path="/miscFees" element={<MiscFees />} />
            <Route path="/terms" element={<DocLink title="Terms and Conditions" component={<TandC />} />} />
            <Route path="/privacy" element={<DocLink title="Privacy Policy" component={<Privacy />} />} />
            <Route path="/refund" element={<DocLink title="Refunds / Credits" component={<Refund />} />} />
            <Route path="/contact" element={<DocLink title="Help & Contact" component={<ContactUs />} />} />
            <Route path="/shortterms" element={<DocLink title="Terms and Conditions" component={<ShortTandC />} />} />
        </Routes>
    );
}

export default MainRouter;
